export default __webpack_public_path__ + "static/media/ripple3.8ff66e9e.png";